/* hs-eslint ignored failing-rules */

/* eslint-disable no-prototype-builtins */
'use es6';

import Immutable from 'immutable';
import Review from 'ecosystem-marketplace-core/records/Review';
import ReviewsStats from 'ecosystem-marketplace-core/records/ReviewStats';
import ReviewFilters from 'ecosystem-marketplace-core/records/ReviewFilters';
import * as ReviewTypes from 'marketplace-ui-reviews/constants/ReviewType';
import * as ActionTypes from '../actions/ActionTypes';
import { PAGE_KEY, REVIEWS_PER_PAGE } from 'ecosystem-marketplace-core/constants/reviews/ReviewsListQueries';
const initialState = Immutable.fromJS({
  list: new Immutable.List(),
  stats: new ReviewsStats(),
  total: 0,
  filters: new ReviewFilters()
});

const reviews = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case ActionTypes.REVIEWS_FETCH_RECEIVED:
      return state.set('list', new Immutable.List(Review.fromArray(payload.reviews))).set('total', payload.total);

    case ActionTypes.REVIEWS_STATS_RECEIVED:
      return state.set('stats', ReviewsStats.from(payload).set('reviewType', ReviewTypes.APP));

    case ActionTypes.REVIEW_HELPFUL_RECEIVED:
      {
        const indexToUpdate = state.get('list').findIndex(review => review.get('id') === payload.reviewId);
        return state.set('list', state.get('list').update(indexToUpdate, review => review.toggleHelpful(payload.reviewId, payload.userId, payload.isHelpful)));
      }

    case ActionTypes.DETAILS_FETCH_RECEIVED:
      return state.set('filters', ReviewFilters.from({
        reviewType: ReviewTypes.APP,
        offeringId: payload.offeringId
      }));

    case ActionTypes.REVIEW_FILTERS_UPDATED:
      {
        const page = PAGE_KEY.toLowerCase();
        let newFilters = state.get('filters').merge(payload);

        if (!payload.hasOwnProperty(page)) {
          newFilters = newFilters.merge({
            [page]: 1
          });
        }

        return state.set('filters', newFilters);
      }

    case ActionTypes.NEW_REVIEW_SUBMITTED:
      {
        const newList = state.get('list').size === REVIEWS_PER_PAGE ? state.get('list').pop().unshift(payload) : state.get('list').unshift(payload);
        return state.set('list', newList).set('total', newList.size).set('stats', state.get('stats').addNewStats(payload.ratings));
      }

    default:
      return state;
  }
};

export default reviews;